import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = ({ data }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      {/* -----------top-nav----------- */}

      <div className="topnav">
        <div className="topnav-row">
          <div className="topnav-col">
            <p style={{ textTransform: "uppercase" }}>
              Clinic Timing
              <i
                style={{ color: "#ffff", margin: "0 8px" }}
                className="fas fa-long-arrow-alt-right globalcolor"
              ></i>
              10:30 AM - 2:00 PM | 5:30 PM - 9:00 PM
            </p>
          </div>
          <div className="topnav-col topnav-col-1">
            <div className="topnav-contact">
              <i className="fa-solid fa-envelope"></i>
              <a href="mailto:rootntoothdentalclinic@gmail.com">
                <span>rootntoothdentalclinic@gmail.com</span>
              </a>
            </div>
            <div className="topnav-contact">
              <i class="fa-solid fa-phone-volume"></i>
              <a href="tel:7771949867">
                <span>+91-7771949867</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------------Menu-bar---------------------------- */}
      <div className="menu-bar pc-menubar">
        <div className="menubar-row">
          <div className="menubar-col-1">
            <img src="/logoraj1.png" alt="" />
          </div>
          <div className="menubar-col-1">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/aboutus">About Us </Link>
              </li>

              <li>
                <Link to="/newsphotos">News updates </Link>
              </li>
              <li>
                <a href="/facilities">Facilities</a>
              </li>
              {/* <li> */}
              {/* <a 
                onClick={() => setDownt(!downt)}
                href="#">
                  Treatments
                  <button
                    onClick={() => setDownt(!downt)}
                    className="drop-icon"
                  >
                    {downt ? (
                      <i class=" drop-icon fa-solid fa-minus"></i>
                    ) : (
                      <i class=" drop-icon fa-solid fa-plus"></i>
                    )}
                  </button>
                </a> */}
              {/* {downt ? (
                  <div className="drop-link" onClick={() => setDownt(!downt)}>
                    <li>
                      <Link to="/diabetes">Preventive Treatment</Link>
                    </li>
                    <li>
                      <Link to="/heart">Cosmetic Dentistry Treatment</Link>
                    </li>
                    <li>
                      <Link to="/children"> Orthodontic Treatment</Link>
                    </li>
                    <li>
                      <Link to="/respiration"> Periodontal (Gum) Treatment</Link>
                    </li>
                    <li>
                      <Link to="/tyhroid">Pediatric Dentistry Treatment </Link>
                    </li>
                   
                  </div>
                ) : (
                  ""
                )} */}
              {/* </li> */}

              <li>
                <Link to="/gallery">Our Gallery</Link>
              </li>
              <li>
                <Link to="/After-before">After-Before</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="menu-bar mobile-menubar">
        <div className="menubar-row">
          <div className="menubar-col-1">
            <img src="./images/logo1.png" alt="" />
          </div>

          <div className={show ? "menubar-mobile" : "menubar-col-1"}>
            <ul>
              <button className="close-menu" onClick={() => setShow(!show)}>
                {show ? <i class="fa-solid fa-xmark"></i> : null}
              </button>
              <li onClick={() => setShow(!show)}>
                <Link to="/">Home</Link>
              </li>
              <li onClick={() => setShow(!show)}>
                <Link to="/aboutus">About Us</Link>
              </li>
              <li onClick={() => setShow(!show)}>
                <Link to="/newsphotos">News updates </Link>
              </li>


              {/* <li> */}
              {/* <a 
                href="#">
                  Treatments
                  <button
                    onClick={() => setDownt(!downt)}
                    className="drop-icon"
                  >
                    {downt ? (
                      <i class=" drop-icon fa-solid fa-minus"></i>
                    ) : (
                      <i class=" drop-icon fa-solid fa-plus"></i>
                    )}
                  </button>
                </a> */}
              {/* {downt ? (
                  <div className="drop-link" onClick={() => setDownt(!downt)}>
                    <li onClick={() => setShow(!show)}>
                      <Link to="/diabetes">Preventive Treatment</Link>
                    </li>
                    <li onClick={() => setShow(!show)}>
                      <Link to="/heart">Cosmetic Dentistry Treatment</Link>
                    </li>
                    <li onClick={() => setShow(!show)}>
                      <Link to="/children"> Orthodontic Treatment</Link>
                    </li>
                    <li onClick={() => setShow(!show)}>
                      <Link to="/respiration"> Periodontal (Gum) Treatment </Link>
                    </li>
                    <li onClick={() => setShow(!show)}>
                      <Link to="/tyhroid"> Pediatric Dentistry Treatment </Link>
                    </li>
                    
                  </div>
                ) : (
                  ""
                )} */}
              {/* </li> */}

              <li onClick={() => setShow(!show)}>
                <Link to="/gallery">Our Gallery</Link>
              </li>
              <li onClick={() => setShow(!show)}>
                <Link to="/After-before">After-Before</Link>
              </li>
              <li onClick={() => setShow(!show)}>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
          <button className="menu-icon" onClick={() => setShow(!show)}>
            {show ? (
              <i class="fa-solid fa-bars"></i>
            ) : (
              <i class="fa-solid fa-bars"></i>
            )}
          </button>
        </div>
      </div>

      {/* <button onClick={()=>setDownt(!downt)
              } className="drop-icon">{downt?<i class=" drop-icon fa-solid fa-minus"></i>:<i class=" drop-icon fa-solid fa-plus"></i>}</button>
              {
              downt?<div className="drop-link" onClick={()=>setDownt(!downt)}>
              <li  onClick={()=>setShow(!show)}><a href="/nervoussystem">Head / Brain & Nervous System </a></li>
               <li  onClick={()=>setShow(!show)}><a to="/respiration">Respiratory System </a></li>
               <li  onClick={()=>setShow(!show)}><a to="/urinary">Urinary system</a></li>
               <li  onClick={()=>setShow(!show)}><a to="/heart">Heart & Blood Circulation </a></li>
               <li  onClick={()=>setShow(!show)}><a to="/liver">Liver & Gallbladder</a></li>
               <li  onClick={()=>setShow(!show)}><a to="/eyesight">Eyes/ Sight</a></li>
               <li  onClick={()=>setShow(!show)}><a to="/mouth">Mouth, Tongue & Throat</a></li>
              </div>:""
            } */}
    </>
  );
};

export default Header;
